import { INTEGRATIONS } from "icons";
import { NavItem } from "../../../components/nav/item";

export function IntegrationsNavigations() {

  return (
    <NavItem
      title={
        <span className="flex justify-between">
          Integrations{" "}
        </span>
      }
          icon={INTEGRATIONS}
      url="/integrations"
    />
  );
}
